import { Link, NavLink, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function PublicLayout() {
  const { t, i18n } = useTranslation();
  const setLanguage = (language: "en" | "es") => {
    void i18n.changeLanguage(language);
    localStorage.setItem("hopehangar-locale", language);
  };
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-primary/10 bg-background/95 backdrop-blur">
        <div className="mx-auto flex h-18 max-w-6xl items-center justify-between px-5 py-4">
          <Link to="/" className="shrink-0" aria-label="Hope Hangar home">
            <img
              src="/brand/hope-hangar-logo-black.png"
              alt="Hope Hangar"
              className="h-8 w-auto sm:h-9"
            />
          </Link>
          <nav className="hidden items-center gap-6 text-sm font-medium sm:flex">
            <NavLink to="/" className="hover:text-primary">
              {t("nav.home")}
            </NavLink>
            <NavLink to="/events" className="hover:text-primary">
              {t("nav.events")}
            </NavLink>
          </nav>
          <div
            className="flex items-center gap-1 rounded-full border bg-white p-1"
            aria-label={t("common.language")}
          >
            <Button
              size="sm"
              variant={i18n.language.startsWith("en") ? "default" : "ghost"}
              className="h-8 rounded-full px-3"
              onClick={() => setLanguage("en")}
            >
              EN
            </Button>
            <Button
              size="sm"
              variant={i18n.language.startsWith("es") ? "default" : "ghost"}
              className="h-8 rounded-full px-3"
              onClick={() => setLanguage("es")}
            >
              ES
            </Button>
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="border-t bg-primary px-5 py-10 text-primary-foreground">
        <div className="mx-auto flex max-w-6xl flex-col justify-between gap-5 sm:flex-row sm:items-center">
          <img
            src="/brand/hope-hangar-logo-white.png"
            alt="Hope Hangar"
            className="h-9 w-auto self-start"
          />
          <p className="text-sm text-primary-foreground/75">
            {t("common.footerTagline")}
          </p>
        </div>
      </footer>
    </div>
  );
}
